/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Not_Ready_BodyInputs */

const en_us2_wrapped_not_ready_body = /** @type {(inputs: Wrapped_Not_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Once a week with a workout closes, its numbers become cards here.`)
};

const pt_br2_wrapped_not_ready_body = /** @type {(inputs: Wrapped_Not_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando uma semana com treino fechar, os números dela viram cartões aqui.`)
};

const es_419_wrapped_not_ready_body = /** @type {(inputs: Wrapped_Not_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuando se cierre una semana con entrenamiento, sus números se vuelven tarjetas aquí.`)
};

const pt_pt2_wrapped_not_ready_body = /** @type {(inputs: Wrapped_Not_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando uma semana com treino fechar, os números dela tornam-se cartões aqui.`)
};

const fr_fr2_wrapped_not_ready_body = /** @type {(inputs: Wrapped_Not_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dès qu'une semaine avec une séance se termine, ses chiffres deviennent des cartes ici.`)
};

const de_de2_wrapped_not_ready_body = /** @type {(inputs: Wrapped_Not_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobald eine Woche mit Training abgeschlossen ist, werden ihre Zahlen hier zu Karten.`)
};

const it_it2_wrapped_not_ready_body = /** @type {(inputs: Wrapped_Not_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando si chiude una settimana con un allenamento, i suoi numeri diventano schede qui.`)
};

/**
* | output |
* | --- |
* | "Once a week with a workout closes, its numbers become cards here." |
*
* @param {Wrapped_Not_Ready_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_not_ready_body = /** @type {((inputs?: Wrapped_Not_Ready_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Not_Ready_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_not_ready_body(inputs)
	if (locale === "es-419") return es_419_wrapped_not_ready_body(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_not_ready_body(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_not_ready_body(inputs)
	if (locale === "de-DE") return de_de2_wrapped_not_ready_body(inputs)
	if (locale === "it-IT") return it_it2_wrapped_not_ready_body(inputs)
	return en_us2_wrapped_not_ready_body(inputs)
});
export { wrapped_not_ready_body as "wrapped.not_ready_body" }